var stickyHeader = (function () {


    var setUpStickyHeader = function () {
        // Add sticky header on scroll
        $(window).scroll(function() {
            var scroll = $(window).scrollTop();
            var element = $('.c-home-header-wrapper');
            var elementHeight = $('.c-home-header-wrapper').innerHeight();
            var topSectionHeight = $('.c-live-return-wrapper').innerHeight();
            var homeBannerHeight = $('.c-home-banner-bg').innerHeight();
        
            // Add pinned header class for changing styling
            if (scroll >= elementHeight + topSectionHeight + 20 ) {
                element.addClass("pinned-header");
            } else {
                element.removeClass("pinned-header");
            }

            // Add sticky header class for fix position
            if (scroll >= homeBannerHeight/2 ) {
                element.addClass("sticky-header");
            } else {
                element.removeClass("sticky-header");
            }
        
        });
    };
  
    var init = function () {
      setUpStickyHeader();
    };
  
    return {
      init: init
    };
  })();
  
  export default stickyHeader;


// WEBPACK FOOTER //
// ./FE-Build/src/js/modules/stickyHeader.js